import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import {
  DialogModule,
  ErrorHandlerModule,
  ErrorHandlerService,
  KeynavModule,
  LoginModule,
  ModalModule,
  SwipeModule,
  ToastModule
} from '@inera/common';
import { IDButtonModule } from '@inera/ids-angular/components/button';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationService } from './module/backend/api';
import { BackendModule } from './module/backend/backend.module';
import { IdpErrorHandlerService, UserChoicesGuardService } from './module/idp/service';
import { ThemeHandlerService } from './module/idp/service/theme-handler.service';
import { EidasAuthenticationComponent } from './module/idp/view/eidas-authentication/eidas-authentication.component';
import { LoggedoutComponent } from './module/idp/view/loggedout/loggedout.component';
import { MtlsNoCertificateComponent } from './module/idp/view/mtls-no-certificate/mtls-no-certificate.component';
import { MtlsRotationLimitComponent } from './module/idp/view/mtls-rotation-limit/mtls-rotation-limit.component';
import { RootModule } from './module/root/root.module';
import { LoadingSpinnerComponent } from './module/shared/component/loading-spinner/loading-spinner.component';

@NgModule({
  declarations: [],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    DialogModule,
    ToastModule,
    DialogModule,
    ModalModule,
    LoginModule,
    RootModule,
    BackendModule,
    ErrorHandlerModule,
    KeynavModule,
    SwipeModule,
    ReactiveFormsModule,
    IDButtonModule,
    LoadingSpinnerComponent,
    AppComponent,
    LoggedoutComponent,
    MtlsNoCertificateComponent,
    MtlsRotationLimitComponent,
    EidasAuthenticationComponent
  ],
  providers: [
    Title,
    IdpErrorHandlerService,
    ThemeHandlerService,
    AuthenticationService,
    UserChoicesGuardService,
    {
      provide: ErrorHandlerService,
      useClass: IdpErrorHandlerService
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
